import { render, staticRenderFns } from "./UserAllowed.vue?vue&type=template&id=3d274c56"
import script from "./UserAllowed.vue?vue&type=script&lang=js"
export * from "./UserAllowed.vue?vue&type=script&lang=js"
import style0 from "./UserAllowed.vue?vue&type=style&index=0&id=3d274c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports